import { Component, OnInit, ViewChild } from "@angular/core";
import { SwiperComponent, SwiperConfigInterface } from "ngx-swiper-wrapper";
import { ProductService } from "../services/product.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-marcas-carousel",
  templateUrl: "./marcas-carousel.component.html",
  styleUrls: ["./marcas-carousel.component.sass"],
})
export class MarcasCarouselComponent implements OnInit {
  constructor(private productService: ProductService, private router: Router) {}
  public config: SwiperConfigInterface;
  marcasArray: any[] = [];
  param = [
    {
      clave: "Marca",
      valor: "",
    },
    {
      clave: "Codigo",
      valor: "AEQ",
    },
  ];
  async ngOnInit(): Promise<void> {
    this.marcasArray = [];
    this.cargarConfig();
  }
  async obtenerMarcas(param) {
    return await this.productService
      .getMarcas(param)
      .toPromise()
      .catch((error: any) => {});
  }
  async ngAfterViewInit() {
    this.marcasArray = [];
    this.cargarConfig();
  }
  selectMarca(item: any) {
    this.router.navigate(["/home/products/", 0, 0, 0, item.Marca, 0, 0, 1]);
  }
  async cargarConfig() {
    let marcas: any = await this.obtenerMarcas(this.param);
    this.marcasArray = marcas.filter((x) => x.Cant > 1);
    this.marcasArray.forEach(x => {
      if(x.OrdenM == 0){
        x.OrdenM = 189
      }
    })
    this.marcasArray.sort(function (a, b) {
      return a.OrdenM - b.OrdenM;
    })
    setTimeout(() => {
      this.config = {
        observer: true,
        slidesPerView: 7,
        spaceBetween: 16,
        keyboard: true,
        navigation: true,
        pagination: false,
        grabCursor: true,
        loop: false,
        preloadImages: false,
        lazy: true,
        breakpoints: {
          1500: {
            slidesPerView: 7,
            spaceBetween: 15,
          },
          1000: {
            slidesPerView: 5,
            spaceBetween: 15,
          },
          500: {
            slidesPerView: 2,
            spaceBetween: 5,
          },
        },
      };
    }, 1000);
  }
}
